import { Node } from '@tiptap/core'

export const Span = Node.create({
  name: 'span',
  group: 'inline',
  inline: true,
  content: 'inline*',

  addAttributes() {
    return {
      id: { default: null },
      class: { default: null },
      style: { default: null }
    }
  },

  parseHTML: () => [{ tag: 'span' }],
  renderHTML: ({ HTMLAttributes }) => ['span', HTMLAttributes, 0],
});